import React, { useState } from 'react';
import { getQueryStringArgs } from '@/utils/url-parse';
import { Input } from '@alifd/next';
import { Icon } from '@b-design/fusion';
import Requests from '@/services/request';
import Confirm from '@/components/Confirm';
import $i18n from '@/i18n';
import './index.less';

const EditableInput = (props) => {
  const { setDropdownVisible, value, updateTag, deleteTag, bindTag, bindInfo } = props;
  const [editable, setEditable] = useState(false);
  let timer;

  const onDblClick = () => {
    clearTimeout(timer);
    setEditable(true);
  };

  const changeInputValue = (e) => {
    updateTag(e, value);
    setEditable(false);
  };

  const changeTags = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      bindTag(value.id);
      setDropdownVisible(false);
    }, 200);
  };

  if (editable) {
    return (
      <div className="inputChoose">
        <Input
          className="tagInput"
          autoFocus
          defaultValue={value.name}
          onPressEnter={changeInputValue}
          onBlur={() => setEditable(false)}
          maxLength={30}
        />
        <Confirm
          trigger={<Icon className="deleteTag" type="trash-can--outline" size="xs" />}
          dialogTitle={$i18n.get({
            id: 'aopf.pages.miniAppStore.setting.delete.tag',
            dm: '删除标签',
          })}
          dialogContent={$i18n.get({
            id: 'aopf.pages.miniAppStore.setting.delete.desc.tag',
            dm: '确定删除该标签？',
          })}
          width={400}
          onClick={deleteTag.bind(null, value.id)}
        />
      </div>
    );
  }
  return (
    <div className="tagName">
      {Number(bindInfo?.channelTagId) === value.id ? (
        <Icon type="check-small" style={{ color: 'blue' }} />
      ) : (
        <div style={{ width: '25px', height: '20px' }}> </div>
      )}
      <div className="tagValue" onClick={changeTags} onDoubleClick={onDblClick}>
        {value.name}
      </div>
      <Confirm
        trigger={<Icon className="deleteTag" type="trash-can--outline" size="xs" />}
        dialogTitle={$i18n.get({
          id: 'aopf.pages.miniAppStore.setting.delete.tag',
          dm: '删除标签',
        })}
        dialogContent={$i18n.get({
          id: 'aopf.pages.miniAppStore.setting.delete.desc.tag',
          dm: '确定删除该标签？',
        })}
        width={400}
        onClick={deleteTag.bind(null, value.id)}
      />
    </div>
  );
};

export default EditableInput;
